var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPodcast = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.619 18c2.343-1.585 3.881-4.222 3.881-7.215C21.5 5.933 17.47 2 12.5 2s-9 3.933-9 8.785c0 2.993 1.538 5.63 3.881 7.215m1.479-4c-.841-.85-1.36-1.991-1.36-3.25C7.5 8.128 9.739 6 12.5 6s5 2.127 5 4.75c0 1.26-.519 2.4-1.36 3.25m-3.64 8a2 2 0 0 1-2-2v-2a2 2 0 1 1 4 0v2a2 2 0 0 1-2 2Zm1-11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgPodcast;